import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Account = {
  __typename?: 'Account';
  accountId?: Maybe<Scalars['String']>;
  accountType: AccountType;
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

/** The types of accounts */
export enum AccountType {
  Apple = 'APPLE',
  Event = 'EVENT',
  Google = 'GOOGLE',
  Ovid = 'OVID',
  Shopify = 'SHOPIFY'
}

export type ActionCreateResponse = {
  __typename?: 'ActionCreateResponse';
  ok: Scalars['Boolean'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  firstName?: Maybe<Scalars['String']>;
  /** A Universal Unique ID */
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  shopifyId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  shopifyId?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken?: Maybe<Scalars['String']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  invalidRecaptcha?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  verificationToken?: Maybe<Scalars['String']>;
};

export type AvatarInput = {
  alt?: InputMaybe<Scalars['String']>;
  height: Scalars['Float'];
  src: Scalars['String'];
  width: Scalars['Float'];
};

export type Campaign = {
  __typename?: 'Campaign';
  actionName?: Maybe<Scalars['String']>;
  askYear?: Maybe<Scalars['Boolean']>;
  /** If true, actions should be created on visiting the URL. */
  createActionOnURLVisit?: Maybe<Scalars['Boolean']>;
  /** Timestamp indicating when this campaign was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The text found on the button to participate in the campaign e.g. “Tweet”, “Follow”, etc. */
  ctaText?: Maybe<Scalars['String']>;
  defaultEmailBody?: Maybe<Scalars['String']>;
  /** Information on how to complete the campaign. */
  details?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  /** Time stamp indicating the end date and time set for scheduled campaigns. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Campaign dependent. For TwitterRetweetCampaign, it's the tweet id to retweet. */
  entityId?: Maybe<Scalars['String']>;
  excludeAudienceIds?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  extraCopy1?: Maybe<Scalars['String']>;
  extraCopy2?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Scalars['String']>;
  /**
   * Image used for campaign. If it's a URL, then it's an image.
   *     Otherwise, it's a Font Awesome class name.
   */
  icon?: Maybe<Scalars['String']>;
  /** Unique campaign id */
  id?: Maybe<Scalars['Float']>;
  includeAudienceIds?: Maybe<Scalars['String']>;
  /** The maximum number of times a single customer can complete this campaign. */
  maxCompletionsPerUser?: Maybe<Scalars['Int']>;
  /** The number of actions (for punch card style campaigns) that are required for the campaign to be completed. */
  minActionsRequired?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  /** Describes what the customer gets for completing (e.g. “500 Points”). */
  rewardText?: Maybe<Scalars['String']>;
  /** Message to be shared on social media, used in the TwitterTweetCampaign. */
  shareText?: Maybe<Scalars['String']>;
  /** The status of the campaign. Only set if a valid JWT is sent in the header. */
  status?: Maybe<CampaignStatus>;
  /** Campaign headline/One-liner */
  title?: Maybe<Scalars['String']>;
  /**
   * One of the various campaign types, such as: SpendBasedCampaign,
   *       TransactionBasedCampaign, ReferralCampaign, TwitterRetweetCampaign, InstagramFollowCampaign,
   *       TwitterTweetCampaign, TwitterFollowCampaign, etc.
   */
  type?: Maybe<Scalars['String']>;
  unrenderedDetails?: Maybe<Scalars['String']>;
  unrenderedTitle?: Maybe<Scalars['String']>;
  /** Timestamp reflecting the last update to this campaign. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Campaign dependent. Sometimes a destination to link to from call-to-action button, for TwitterTweet
   *       it's a url to be included in the tweet.
   */
  url?: Maybe<Scalars['String']>;
  /** Campaign dependent. For TwitterFollowCampaign, it's the Twitter handle to follow. */
  username?: Maybe<Scalars['String']>;
};

export type CampaignStatus = {
  __typename?: 'CampaignStatus';
  /** Number of actions the customer has performed towards this campaign. */
  customerActionsCompleted: Scalars['Float'];
  /**
   * The number of minutes the customer must wait until they can complete take another action
   *       towards completing this campaign.
   */
  customerMinutesUntilNextAction: Scalars['Int'];
  /** Number of minutes the customer must wait until they are eligible to complete this campaign again. */
  customerMinutesUntilNextCompletion: Scalars['Int'];
  /** Number of times the customer has already completed this campaign. */
  customerTimesCompleted: Scalars['Int'];
  /** Number of times this campaign can be completed globally (for all customers in total). */
  globalCompletionsLeft?: Maybe<Scalars['Int']>;
};

export type CampaignsResponse = {
  __typename?: 'CampaignsResponse';
  campaigns: Array<Campaign>;
  title: Scalars['String'];
};

export type ConfirmResponse = {
  __typename?: 'ConfirmResponse';
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  error?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'FAQ';
  description: Scalars['String'];
  id: Scalars['Int'];
  /** The Frequently Asked Question */
  title: Scalars['String'];
};

export type FaQs = {
  __typename?: 'FAQs';
  /** The FAQ list description */
  description: Scalars['String'];
  /** A list of FAQ items */
  faqs: Array<Faq>;
  /** The FAQ list title */
  title: Scalars['String'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  email?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type Image = {
  __typename?: 'Image';
  alt: Scalars['String'];
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  height: Scalars['Float'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  src: Scalars['String'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
  width: Scalars['Float'];
};

export type LoyaltyHistory = {
  __typename?: 'LoyaltyHistory';
  /** A list of Loyalty History items */
  items: Array<LoyaltyHistoryItem>;
};

export type LoyaltyHistoryItem = {
  __typename?: 'LoyaltyHistoryItem';
  /** The name of the action taken */
  action?: Maybe<Scalars['String']>;
  /** The name of the action taken */
  actionName?: Maybe<Scalars['String']>;
  /** The full date the action was completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The full date the action was created */
  createdAt: Scalars['DateTime'];
  /** The date of the action YYYY-MM-DD */
  date?: Maybe<Scalars['String']>;
  /** The points associated with the action */
  points?: Maybe<Scalars['Int']>;
  /** Approved or the reward text */
  status?: Maybe<Scalars['String']>;
};

export type LoyaltyStatus = {
  __typename?: 'LoyaltyStatus';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  optIn?: Maybe<Scalars['Boolean']>;
  pointsBalance?: Maybe<Scalars['Int']>;
  pointsEarned?: Maybe<Scalars['Int']>;
  pointsExpireAt?: Maybe<Scalars['DateTime']>;
  tierEntryDate?: Maybe<Scalars['DateTime']>;
  tierExpiresAt?: Maybe<Scalars['DateTime']>;
  tierName?: Maybe<Scalars['String']>;
  tierUpgradeRequirements?: Maybe<LoyaltyTierRequirements>;
  totalPurchases?: Maybe<Scalars['Int']>;
  totalSpendCents?: Maybe<Scalars['Int']>;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type LoyaltyTierRequirements = {
  __typename?: 'LoyaltyTierRequirements';
  amountCentsNeeded?: Maybe<Scalars['Int']>;
  amountCentsNeededInCustomerCurrency?: Maybe<Scalars['Int']>;
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  pointsNeeded?: Maybe<Scalars['Int']>;
  purchasesNeeded?: Maybe<Scalars['Int']>;
  referralsNeeded?: Maybe<Scalars['Int']>;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type MultipassResponse = {
  __typename?: 'MultipassResponse';
  multipassToken?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountConfirm: ConfirmResponse;
  addressAdd: Address;
  addressDelete?: Maybe<Address>;
  addressEdit: Address;
  appAppleTokenVerify?: Maybe<VerifyTokenResponse>;
  appGoogleTokenVerify?: Maybe<VerifyTokenResponse>;
  appMultipassCreate?: Maybe<MultipassResponse>;
  appTokenRefresh?: Maybe<TokenResponse>;
  appVerifyAccount?: Maybe<TokenResponse>;
  avatarAdd: User;
  loyaltyActionCreate?: Maybe<ActionCreateResponse>;
  loyaltyOptIn?: Maybe<OptInOutResponse>;
  loyaltyOptOut?: Maybe<OptInOutResponse>;
  loyaltyRedemptionOptionRedeem?: Maybe<RedemptionOptionRedeemResponse>;
  loyaltySubscribe: User;
  loyaltyUnsubscribe: User;
  userEdit: User;
  userForgotPassword?: Maybe<StatusResponse>;
  userForgotPasswordWithToken?: Maybe<ForgotPasswordResponse>;
  userLogin?: Maybe<AuthResponse>;
  userLogout: Scalars['Boolean'];
  userProgramCreate: UserProgram;
  userRegister: AuthResponse;
  userSetPasswordWithAccessToken?: Maybe<AuthResponse>;
  userSetPasswordWithPassword: StatusResponse;
  userSetPasswordWithToken: StatusResponse;
  /** A mutation to add a new wish list */
  wishListAdd: WishList;
  /** A mutation to delete a wish list by id. If a wish list cannot be found, it will return null */
  wishListDelete?: Maybe<WishList>;
  /** A mutation to edit a wish list */
  wishListEdit: WishList;
  /**
   * A mutation to create a wish list item.
   *     If no wishListId is passed, it will default to the first wish list.
   *     If there is no wish list, it will create one.
   */
  wishListItemAdd: WishList;
  /** A mutation to delete a wish list item. */
  wishListItemDelete?: Maybe<WishList>;
};


export type MutationAccountConfirmArgs = {
  token: Scalars['String'];
};


export type MutationAddressAddArgs = {
  input: AddressInput;
};


export type MutationAddressDeleteArgs = {
  id: Scalars['String'];
};


export type MutationAddressEditArgs = {
  input: AddressInput;
};


export type MutationAppAppleTokenVerifyArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationAppGoogleTokenVerifyArgs = {
  token: Scalars['String'];
};


export type MutationAppMultipassCreateArgs = {
  token: Scalars['String'];
};


export type MutationAppTokenRefreshArgs = {
  refreshToken: Scalars['String'];
};


export type MutationAppVerifyAccountArgs = {
  verificationToken: Scalars['String'];
};


export type MutationAvatarAddArgs = {
  input: AvatarInput;
};


export type MutationLoyaltyActionCreateArgs = {
  actionName: Scalars['String'];
  customerEmail?: InputMaybe<Scalars['String']>;
};


export type MutationLoyaltyRedemptionOptionRedeemArgs = {
  redemptionOptionId: Scalars['Int'];
  redemptionOptionName: Scalars['String'];
};


export type MutationLoyaltySubscribeArgs = {
  id: Scalars['String'];
};


export type MutationLoyaltyUnsubscribeArgs = {
  id: Scalars['String'];
};


export type MutationUserEditArgs = {
  input: UserEditInput;
};


export type MutationUserForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserProgramCreateArgs = {
  answers: Scalars['String'];
  programId: Scalars['String'];
};


export type MutationUserRegisterArgs = {
  input: RegisterInput;
  recaptchaToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserSetPasswordWithAccessTokenArgs = {
  input: SetPasswordWithAccessTokenInput;
};


export type MutationUserSetPasswordWithPasswordArgs = {
  input: SetPasswordWithPasswordInput;
};


export type MutationUserSetPasswordWithTokenArgs = {
  input: SetPasswordWithTokenInput;
};


export type MutationWishListAddArgs = {
  input: WishListInput;
};


export type MutationWishListDeleteArgs = {
  id: Scalars['String'];
};


export type MutationWishListEditArgs = {
  input: WishListInput;
};


export type MutationWishListItemAddArgs = {
  input: WishListItemInput;
};


export type MutationWishListItemDeleteArgs = {
  id: Scalars['String'];
};

export type NextTier = {
  __typename?: 'NextTier';
  message: Scalars['String'];
  perks: Array<Perk>;
  perksTitle: Scalars['String'];
};

export type OptInOutResponse = {
  __typename?: 'OptInOutResponse';
  ok: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type Order = {
  __typename?: 'Order';
  creditCardCompany?: Maybe<Scalars['String']>;
  creditCardNumber?: Maybe<Scalars['String']>;
  lineItems: Array<OrderLineItem>;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  image?: Maybe<OrderLineItemImage>;
  name: Scalars['String'];
  shopifyProductId: Scalars['Float'];
  shopifyVariantId: Scalars['Float'];
};

export type OrderLineItemImage = {
  __typename?: 'OrderLineItemImage';
  alt: Scalars['String'];
  height: Scalars['Float'];
  id: Scalars['String'];
  src: Scalars['String'];
  width: Scalars['Float'];
};

export type Perk = {
  __typename?: 'Perk';
  /** The disclaimer of the perk */
  disclaimer?: Maybe<Scalars['String']>;
  /** The ID of the perk */
  id: Scalars['Int'];
  /** The title of the perk */
  title: Scalars['String'];
};

export type Perks = {
  __typename?: 'Perks';
  /** A list of perks for the OV Rewards Program, e.g. Birthday Gift */
  perks: Array<Perk>;
  title: Scalars['String'];
};

export type Profile = {
  __typename?: 'Profile';
  avatar?: Maybe<Image>;
  birthday?: Maybe<Scalars['DateTime']>;
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  favoriteActivity?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Float']>;
  /** A Universal Unique ID */
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['JSON']>;
  shoppingFor?: Maybe<Scalars['String']>;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type Program = {
  __typename?: 'Program';
  adminTitle: Scalars['String'];
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  postActivationCTA: Scalars['String'];
  postActivationDescription: Scalars['String'];
  postActivationTitle: Scalars['String'];
  postActivationURL: Scalars['String'];
  preActivationDescription: Scalars['String'];
  preActivationTitle: Scalars['String'];
  promoCode: Scalars['String'];
  questions: Scalars['String'];
  title: Scalars['String'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts: Array<Account>;
  address?: Maybe<Address>;
  addresses: Array<Address>;
  loyaltyCampaigns?: Maybe<CampaignsResponse>;
  loyaltyFAQs: FaQs;
  loyaltyHistory: LoyaltyHistory;
  loyaltyPerks: Perks;
  loyaltyRedemptionOptions?: Maybe<RedemptionOptionsResponse>;
  loyaltyStatus?: Maybe<LoyaltyStatus>;
  loyaltySteps: Steps;
  loyaltyTiers: Tiers;
  me?: Maybe<User>;
  ordersRecent?: Maybe<Order>;
  programs: Array<Program>;
  recreationalistLatest: RecreationalistItem;
  schoolColor?: Maybe<SchoolColor>;
  /** A wish list with the owner attribute set; returns null if the wish list cannot be found */
  wishList?: Maybe<WishList>;
  /** A list of wish lists of the currently logged in user */
  wishLists: Array<WishList>;
};


export type QueryAccountArgs = {
  token: Scalars['String'];
};


export type QueryAddressArgs = {
  id: Scalars['String'];
};


export type QueryAddressesArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrdersRecentArgs = {
  id: Scalars['Float'];
};


export type QueryProgramsArgs = {
  eligible?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySchoolColorArgs = {
  email: Scalars['String'];
};


export type QueryWishListArgs = {
  id: Scalars['String'];
};

export type RecreationalistItem = {
  __typename?: 'RecreationalistItem';
  category: Scalars['String'];
  description: Scalars['String'];
  image: Scalars['String'];
  link: Scalars['String'];
  title: Scalars['String'];
};

export type RedemptionOption = {
  __typename?: 'RedemptionOption';
  amount?: Maybe<Scalars['String']>;
  appliesToProductType?: Maybe<Scalars['String']>;
  /** How many points this option costs. e.g. 500 points */
  costText?: Maybe<Scalars['String']>;
  /** Short Description. e.g. Get $5.00 off every item in our store for 500 points */
  description?: Maybe<Scalars['String']>;
  discountAmountCents?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  discountRateCents?: Maybe<Scalars['Int']>;
  discountType?: Maybe<Scalars['String']>;
  discountValueCents?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The redemption option unique id */
  id: Scalars['Int'];
  /** Option Title e.g. $5.00 off */
  name?: Maybe<Scalars['String']>;
  /** True if the user can redeem this option. Only set if a valid JWT is sent in the header. */
  redeemable?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  unrenderedDescription?: Maybe<Scalars['String']>;
  unrenderedName?: Maybe<Scalars['String']>;
};

export type RedemptionOptionRedeemResponse = {
  __typename?: 'RedemptionOptionRedeemResponse';
  amount?: Maybe<Array<Scalars['String']>>;
  approved?: Maybe<Scalars['Boolean']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  atCheckout?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  errors?: Maybe<Array<ErrorType>>;
  id?: Maybe<Scalars['Int']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isPos?: Maybe<Scalars['Boolean']>;
  /** True if the redemption created successfully */
  ok: Scalars['Boolean'];
  rewardText?: Maybe<Scalars['String']>;
  thirdPartyId?: Maybe<Scalars['String']>;
  thirdPartyRuleId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variantId?: Maybe<Scalars['Int']>;
};

export type RedemptionOptionsResponse = {
  __typename?: 'RedemptionOptionsResponse';
  options: Array<RedemptionOption>;
  title: Scalars['String'];
};

export type RegisterInput = {
  birthday?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  shoppingFor?: InputMaybe<Scalars['String']>;
  signUp: Scalars['Boolean'];
};

export type SchoolColor = {
  __typename?: 'SchoolColor';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  emailDomain: Scalars['String'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  name: Scalars['String'];
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type SetPasswordWithAccessTokenInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type SetPasswordWithPasswordInput = {
  newPassword: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type SetPasswordWithTokenInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type Step = {
  __typename?: 'Step';
  /** The description of the step */
  description: Scalars['String'];
  /** The ID of the step */
  id: Scalars['Int'];
  /** The label of the step */
  label: Scalars['String'];
  /** The title of the step */
  title: Scalars['String'];
};

export type Steps = {
  __typename?: 'Steps';
  /** The FAQ list description */
  description: Scalars['String'];
  /** A list of steps for the OV Rewards Program, e.g. Spend or Save */
  steps: Array<Step>;
  /** The FAQ list title */
  title: Scalars['String'];
};

export type Threshold = {
  __typename?: 'Threshold';
  amountSpentCents: Scalars['Int'];
  pointsEarned: Scalars['Int'];
  purchasesMade: Scalars['Int'];
  referralsCompleted: Scalars['Int'];
  requirementsNeeded?: Maybe<Scalars['String']>;
};

export type Tier = {
  __typename?: 'Tier';
  birthdayGift: Scalars['String'];
  color: Scalars['String'];
  entryThreshold: Threshold;
  id: Scalars['Int'];
  image: Scalars['String'];
  nextTier: NextTier;
  perkIds: Array<Scalars['Int']>;
  spend: Scalars['String'];
  title: Scalars['String'];
};

export type Tiers = {
  __typename?: 'Tiers';
  tiers: Array<Tier>;
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  accessToken?: Maybe<Scalars['String']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasPassword: Scalars['Boolean'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  loyaltyStatus: LoyaltyStatus;
  profile: Profile;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type UserEditInput = {
  birthday?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['JSON']>;
  shoppingFor?: InputMaybe<Scalars['String']>;
};

export type UserProgram = {
  __typename?: 'UserProgram';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  program: Program;
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type VerifyTokenResponse = {
  __typename?: 'VerifyTokenResponse';
  accessToken?: Maybe<Scalars['String']>;
  isNewRegistration?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type WishList = {
  __typename?: 'WishList';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  /**
   * False if the wishlist is being requested by someone who is not the owner;
   *       currently, only available in a View Query
   */
  isOwner: Scalars['Boolean'];
  /** All of the items a user has added to their wish list */
  items: Array<WishListItem>;
  /** The title of a wish list; currently, auto-generated */
  title: Scalars['String'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
  /** The owner's first name */
  userFirstName: Scalars['String'];
};

export type WishListInput = {
  /** The id of a wish list */
  id?: InputMaybe<Scalars['String']>;
  /** The title of a wish list */
  title: Scalars['String'];
};

export type WishListItem = {
  __typename?: 'WishListItem';
  /** The date and time this model was created */
  createdAt: Scalars['DateTime'];
  /** The Global ID from EMS */
  emsColorwayGid: Scalars['String'];
  /** The Global ID from EMS */
  emsProductGid: Scalars['String'];
  /** A Universal Unique ID */
  id: Scalars['ID'];
  /** The date and time this model was updated */
  updatedAt: Scalars['DateTime'];
};

export type WishListItemInput = {
  /** The Global ID from EMS */
  emsColorwayGid: Scalars['String'];
  /** The Global ID from EMS */
  emsProductGid: Scalars['String'];
  /** The optional id of a wish list to add an item to. */
  wishListId?: InputMaybe<Scalars['String']>;
};

export type AccountConfirmMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AccountConfirmMutation = { __typename?: 'Mutation', accountConfirm: { __typename?: 'ConfirmResponse', accessToken?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any } | null } };

export type AccountQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type AccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, email: string } | null };

export type AccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, email: string, accountId?: string | null, accountType: AccountType, isDefault: boolean, isVerified: boolean, updatedAt: any, createdAt: any }> };

export type AvatarAddMutationVariables = Exact<{
  input: AvatarInput;
}>;


export type AvatarAddMutation = { __typename?: 'Mutation', avatarAdd: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, avatar?: { __typename?: 'Image', id: string, alt: string, src: string, height: number, width: number } | null } } };

export type CampaignFragment = { __typename?: 'Campaign', actionName?: string | null, createActionOnURLVisit?: boolean | null, ctaText?: string | null, details?: string | null, displayOrder?: number | null, icon?: string | null, id?: number | null, maxCompletionsPerUser?: number | null, rewardText?: string | null, title?: string | null, url?: string | null, status?: { __typename?: 'CampaignStatus', customerTimesCompleted: number } | null };

export type ImageFragment = { __typename?: 'Image', id: string, alt: string, src: string, height: number, width: number };

export type LoyaltyActionCreateMutationVariables = Exact<{
  actionName: Scalars['String'];
}>;


export type LoyaltyActionCreateMutation = { __typename?: 'Mutation', loyaltyActionCreate?: { __typename?: 'ActionCreateResponse', ok: boolean } | null };

export type LoyaltyDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyDashboardQuery = { __typename?: 'Query', loyaltyStatus?: { __typename?: 'LoyaltyStatus', id: string, pointsBalance?: number | null, pointsExpireAt?: any | null, optIn?: boolean | null, tierExpiresAt?: any | null, tierName?: string | null, tierUpgradeRequirements?: { __typename?: 'LoyaltyTierRequirements', id: string, amountCentsNeeded?: number | null } | null } | null, loyaltyCampaigns?: { __typename?: 'CampaignsResponse', title: string, campaigns: Array<{ __typename?: 'Campaign', actionName?: string | null, createActionOnURLVisit?: boolean | null, ctaText?: string | null, details?: string | null, displayOrder?: number | null, icon?: string | null, id?: number | null, maxCompletionsPerUser?: number | null, rewardText?: string | null, title?: string | null, url?: string | null, status?: { __typename?: 'CampaignStatus', customerTimesCompleted: number } | null }> } | null, loyaltyFAQs: { __typename?: 'FAQs', description: string, title: string, faqs: Array<{ __typename?: 'FAQ', id: number, title: string, description: string }> }, loyaltyPerks: { __typename?: 'Perks', title: string, perks: Array<{ __typename?: 'Perk', disclaimer?: string | null, id: number, title: string }> }, loyaltyRedemptionOptions?: { __typename?: 'RedemptionOptionsResponse', title: string, options: Array<{ __typename?: 'RedemptionOption', amount?: string | null, description?: string | null, discountAmountCents?: number | null, name?: string | null, icon?: string | null, id: number, redeemable?: boolean | null }> } | null, loyaltyTiers: { __typename?: 'Tiers', tiers: Array<{ __typename?: 'Tier', birthdayGift: string, color: string, id: number, image: string, perkIds: Array<number>, spend: string, title: string, entryThreshold: { __typename?: 'Threshold', amountSpentCents: number }, nextTier: { __typename?: 'NextTier', message: string, perksTitle: string, perks: Array<{ __typename?: 'Perk', id: number, title: string }> } }> } };

export type LoyaltyFaQsFragment = { __typename?: 'FAQs', description: string, title: string, faqs: Array<{ __typename?: 'FAQ', id: number, title: string, description: string }> };

export type LoyaltyHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyHistoryQuery = { __typename?: 'Query', loyaltyHistory: { __typename?: 'LoyaltyHistory', items: Array<{ __typename?: 'LoyaltyHistoryItem', action?: string | null, actionName?: string | null, date?: string | null, completedAt?: any | null, points?: number | null, status?: string | null, createdAt: any }> } };

export type LoyaltyOptInMutationVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyOptInMutation = { __typename?: 'Mutation', loyaltyOptIn?: { __typename?: 'OptInOutResponse', ok: boolean, user?: { __typename?: 'User', profile: { __typename?: 'Profile', preferences?: any | null } } | null } | null };

export type LoyaltyOptOutMutationVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyOptOutMutation = { __typename?: 'Mutation', loyaltyOptOut?: { __typename?: 'OptInOutResponse', ok: boolean, user?: { __typename?: 'User', profile: { __typename?: 'Profile', preferences?: any | null } } | null } | null };

export type LoyaltyPerksFragment = { __typename?: 'Perks', title: string, perks: Array<{ __typename?: 'Perk', disclaimer?: string | null, id: number, title: string }> };

export type LoyaltyRedemptionOptionRedeemMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type LoyaltyRedemptionOptionRedeemMutation = { __typename?: 'Mutation', loyaltyRedemptionOptionRedeem?: { __typename?: 'RedemptionOptionRedeemResponse', approved?: boolean | null, ok: boolean, rewardText?: string | null, token?: string | null, errors?: Array<{ __typename?: 'ErrorType', field?: string | null, error?: string | null }> | null } | null };

export type LoyaltyRedemptionOptionsFragment = { __typename?: 'RedemptionOptionsResponse', title: string, options: Array<{ __typename?: 'RedemptionOption', amount?: string | null, description?: string | null, discountAmountCents?: number | null, name?: string | null, icon?: string | null, id: number, redeemable?: boolean | null }> };

export type LoyaltyQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyQuery = { __typename?: 'Query', loyaltyCampaigns?: { __typename?: 'CampaignsResponse', title: string, campaigns: Array<{ __typename?: 'Campaign', actionName?: string | null, createActionOnURLVisit?: boolean | null, ctaText?: string | null, details?: string | null, displayOrder?: number | null, icon?: string | null, id?: number | null, maxCompletionsPerUser?: number | null, rewardText?: string | null, title?: string | null, url?: string | null, status?: { __typename?: 'CampaignStatus', customerTimesCompleted: number } | null }> } | null, loyaltyFAQs: { __typename?: 'FAQs', description: string, title: string, faqs: Array<{ __typename?: 'FAQ', id: number, title: string, description: string }> }, loyaltyPerks: { __typename?: 'Perks', title: string, perks: Array<{ __typename?: 'Perk', disclaimer?: string | null, id: number, title: string }> }, loyaltyRedemptionOptions?: { __typename?: 'RedemptionOptionsResponse', title: string, options: Array<{ __typename?: 'RedemptionOption', amount?: string | null, description?: string | null, discountAmountCents?: number | null, name?: string | null, icon?: string | null, id: number, redeemable?: boolean | null }> } | null, loyaltySteps: { __typename?: 'Steps', description: string, title: string, steps: Array<{ __typename?: 'Step', description: string, label: string, title: string, id: number }> }, loyaltyTiers: { __typename?: 'Tiers', tiers: Array<{ __typename?: 'Tier', birthdayGift: string, color: string, id: number, image: string, perkIds: Array<number>, spend: string, title: string }> } };

export type LoyaltyStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyStatusQuery = { __typename?: 'Query', loyaltyStatus?: { __typename?: 'LoyaltyStatus', id: string, pointsBalance?: number | null, pointsExpireAt?: any | null, optIn?: boolean | null, tierName?: string | null } | null };

export type LoyaltySubscribeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type LoyaltySubscribeMutation = { __typename?: 'Mutation', loyaltySubscribe: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', preferences?: any | null } } };

export type TierFragment = { __typename?: 'Tier', birthdayGift: string, color: string, id: number, image: string, perkIds: Array<number>, spend: string, title: string };

export type LoyaltyUnsubscribeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type LoyaltyUnsubscribeMutation = { __typename?: 'Mutation', loyaltyUnsubscribe: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', preferences?: any | null } } };

export type ProfileFragment = { __typename?: 'Profile', id: string, birthday?: any | null, shoppingFor?: string | null };

export type ProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramsQuery = { __typename?: 'Query', eligiblePrograms: Array<{ __typename?: 'Program', id: string, title: string, questions: string, preActivationDescription: string, preActivationTitle: string }>, programs: Array<{ __typename?: 'Program', id: string, title: string, postActivationDescription: string, postActivationTitle: string, postActivationCTA: string, postActivationURL: string }> };

export type RecreationalistLatestQueryVariables = Exact<{ [key: string]: never; }>;


export type RecreationalistLatestQuery = { __typename?: 'Query', recreationalistLatest: { __typename?: 'RecreationalistItem', image: string, link: string, title: string, category: string, description: string } };

export type SchoolColorQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type SchoolColorQuery = { __typename?: 'Query', schoolColor?: { __typename?: 'SchoolColor', primaryColor: string, secondaryColor: string, name: string } | null };

export type UserEditMutationVariables = Exact<{
  input: UserEditInput;
}>;


export type UserEditMutation = { __typename?: 'Mutation', userEdit: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any, profile: { __typename?: 'Profile', id: string, birthday?: any | null, shoppingFor?: string | null } } };

export type UserForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type UserForgotPasswordMutation = { __typename?: 'Mutation', userForgotPassword?: { __typename?: 'StatusResponse', ok?: boolean | null } | null };

export type UserLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type UserLoginMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'AuthResponse', accessToken?: string | null, hasPassword?: boolean | null, invalidRecaptcha?: boolean | null, isVerified?: boolean | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any } | null } | null };

export type UserLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type UserLogoutMutation = { __typename?: 'Mutation', userLogout: boolean };

export type MeWithProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MeWithProfileQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any, profile: { __typename?: 'Profile', id: string, birthday?: any | null, shoppingFor?: string | null, phoneNumber?: string | null, preferences?: any | null, avatar?: { __typename?: 'Image', id: string, alt: string, src: string, height: number, width: number } | null } } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any } | null };

export type OrdersRecentQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type OrdersRecentQuery = { __typename?: 'Query', ordersRecent?: { __typename?: 'Order', creditCardNumber?: string | null, creditCardCompany?: string | null, lineItems: Array<{ __typename?: 'OrderLineItem', shopifyVariantId: number, shopifyProductId: number, name: string, image?: { __typename?: 'OrderLineItemImage', alt: string, src: string, height: number, width: number } | null }> } | null };

export type UserProgramCreateMutationVariables = Exact<{
  programId: Scalars['String'];
  answers: Scalars['String'];
}>;


export type UserProgramCreateMutation = { __typename?: 'Mutation', userProgramCreate: { __typename?: 'UserProgram', id: string, program: { __typename?: 'Program', id: string, title: string, postActivationDescription: string, postActivationTitle: string, postActivationCTA: string, postActivationURL: string } } };

export type UserRegisterMutationVariables = Exact<{
  input: RegisterInput;
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type UserRegisterMutation = { __typename?: 'Mutation', userRegister: { __typename?: 'AuthResponse', accessToken?: string | null, invalidRecaptcha?: boolean | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any } | null } };

export type UserSetPasswordWithAccessTokenMutationVariables = Exact<{
  input: SetPasswordWithAccessTokenInput;
}>;


export type UserSetPasswordWithAccessTokenMutation = { __typename?: 'Mutation', userSetPasswordWithAccessToken?: { __typename?: 'AuthResponse', accessToken?: string | null, hasPassword?: boolean | null, isVerified?: boolean | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any } | null } | null };

export type UserSetPasswordWithPasswordMutationVariables = Exact<{
  input: SetPasswordWithPasswordInput;
}>;


export type UserSetPasswordWithPasswordMutation = { __typename?: 'Mutation', userSetPasswordWithPassword: { __typename?: 'StatusResponse', ok?: boolean | null } };

export type UserSetPasswordWithTokenMutationVariables = Exact<{
  input: SetPasswordWithTokenInput;
}>;


export type UserSetPasswordWithTokenMutation = { __typename?: 'Mutation', userSetPasswordWithToken: { __typename?: 'StatusResponse', ok?: boolean | null } };

export type UserFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, hasPassword: boolean, createdAt: any };

export const CampaignFragmentDoc = gql`
    fragment campaign on Campaign {
  actionName
  createActionOnURLVisit
  ctaText
  details
  displayOrder
  icon
  id
  maxCompletionsPerUser
  rewardText
  title
  status {
    customerTimesCompleted
  }
  url
}
    `;
export const ImageFragmentDoc = gql`
    fragment image on Image {
  id
  alt
  src
  height
  width
}
    `;
export const LoyaltyFaQsFragmentDoc = gql`
    fragment loyaltyFAQs on FAQs {
  description
  faqs {
    id
    title
    description
  }
  title
}
    `;
export const LoyaltyPerksFragmentDoc = gql`
    fragment loyaltyPerks on Perks {
  perks {
    disclaimer
    id
    title
  }
  title
}
    `;
export const LoyaltyRedemptionOptionsFragmentDoc = gql`
    fragment loyaltyRedemptionOptions on RedemptionOptionsResponse {
  options {
    amount
    description
    discountAmountCents
    name
    icon
    id
    redeemable
  }
  title
}
    `;
export const TierFragmentDoc = gql`
    fragment tier on Tier {
  birthdayGift
  color
  id
  image
  perkIds
  spend
  title
}
    `;
export const ProfileFragmentDoc = gql`
    fragment profile on Profile {
  id
  birthday
  shoppingFor
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  firstName
  lastName
  hasPassword
  createdAt
}
    `;
export const AccountConfirmDocument = gql`
    mutation AccountConfirm($token: String!) {
  accountConfirm(token: $token) {
    accessToken
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type AccountConfirmMutationFn = Apollo.MutationFunction<AccountConfirmMutation, AccountConfirmMutationVariables>;

/**
 * __useAccountConfirmMutation__
 *
 * To run a mutation, you first call `useAccountConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountConfirmMutation, { data, loading, error }] = useAccountConfirmMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountConfirmMutation(baseOptions?: Apollo.MutationHookOptions<AccountConfirmMutation, AccountConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountConfirmMutation, AccountConfirmMutationVariables>(AccountConfirmDocument, options);
      }
export type AccountConfirmMutationHookResult = ReturnType<typeof useAccountConfirmMutation>;
export type AccountConfirmMutationResult = Apollo.MutationResult<AccountConfirmMutation>;
export type AccountConfirmMutationOptions = Apollo.BaseMutationOptions<AccountConfirmMutation, AccountConfirmMutationVariables>;
export const AccountDocument = gql`
    query Account($token: String!) {
  account(token: $token) {
    id
    email
  }
}
    `;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountsDocument = gql`
    query Accounts {
  accounts {
    id
    email
    accountId
    accountType
    isDefault
    isVerified
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const AvatarAddDocument = gql`
    mutation AvatarAdd($input: AvatarInput!) {
  avatarAdd(input: $input) {
    id
    profile {
      id
      avatar {
        id
        alt
        src
        height
        width
      }
    }
  }
}
    `;
export type AvatarAddMutationFn = Apollo.MutationFunction<AvatarAddMutation, AvatarAddMutationVariables>;

/**
 * __useAvatarAddMutation__
 *
 * To run a mutation, you first call `useAvatarAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAvatarAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [avatarAddMutation, { data, loading, error }] = useAvatarAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvatarAddMutation(baseOptions?: Apollo.MutationHookOptions<AvatarAddMutation, AvatarAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AvatarAddMutation, AvatarAddMutationVariables>(AvatarAddDocument, options);
      }
export type AvatarAddMutationHookResult = ReturnType<typeof useAvatarAddMutation>;
export type AvatarAddMutationResult = Apollo.MutationResult<AvatarAddMutation>;
export type AvatarAddMutationOptions = Apollo.BaseMutationOptions<AvatarAddMutation, AvatarAddMutationVariables>;
export const LoyaltyActionCreateDocument = gql`
    mutation LoyaltyActionCreate($actionName: String!) {
  loyaltyActionCreate(actionName: $actionName) {
    ok
  }
}
    `;
export type LoyaltyActionCreateMutationFn = Apollo.MutationFunction<LoyaltyActionCreateMutation, LoyaltyActionCreateMutationVariables>;

/**
 * __useLoyaltyActionCreateMutation__
 *
 * To run a mutation, you first call `useLoyaltyActionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyActionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyActionCreateMutation, { data, loading, error }] = useLoyaltyActionCreateMutation({
 *   variables: {
 *      actionName: // value for 'actionName'
 *   },
 * });
 */
export function useLoyaltyActionCreateMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyActionCreateMutation, LoyaltyActionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyActionCreateMutation, LoyaltyActionCreateMutationVariables>(LoyaltyActionCreateDocument, options);
      }
export type LoyaltyActionCreateMutationHookResult = ReturnType<typeof useLoyaltyActionCreateMutation>;
export type LoyaltyActionCreateMutationResult = Apollo.MutationResult<LoyaltyActionCreateMutation>;
export type LoyaltyActionCreateMutationOptions = Apollo.BaseMutationOptions<LoyaltyActionCreateMutation, LoyaltyActionCreateMutationVariables>;
export const LoyaltyDashboardDocument = gql`
    query LoyaltyDashboard {
  loyaltyStatus {
    id
    pointsBalance
    pointsExpireAt
    optIn
    tierExpiresAt
    tierName
    tierUpgradeRequirements {
      id
      amountCentsNeeded
    }
  }
  loyaltyCampaigns {
    campaigns {
      ...campaign
    }
    title
  }
  loyaltyFAQs {
    ...loyaltyFAQs
  }
  loyaltyPerks {
    ...loyaltyPerks
  }
  loyaltyRedemptionOptions {
    ...loyaltyRedemptionOptions
  }
  loyaltyTiers {
    tiers {
      ...tier
      entryThreshold {
        amountSpentCents
      }
      nextTier {
        message
        perksTitle
        perks {
          id
          title
        }
      }
    }
  }
}
    ${CampaignFragmentDoc}
${LoyaltyFaQsFragmentDoc}
${LoyaltyPerksFragmentDoc}
${LoyaltyRedemptionOptionsFragmentDoc}
${TierFragmentDoc}`;

/**
 * __useLoyaltyDashboardQuery__
 *
 * To run a query within a React component, call `useLoyaltyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyDashboardQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyDashboardQuery, LoyaltyDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyDashboardQuery, LoyaltyDashboardQueryVariables>(LoyaltyDashboardDocument, options);
      }
export function useLoyaltyDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyDashboardQuery, LoyaltyDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyDashboardQuery, LoyaltyDashboardQueryVariables>(LoyaltyDashboardDocument, options);
        }
export type LoyaltyDashboardQueryHookResult = ReturnType<typeof useLoyaltyDashboardQuery>;
export type LoyaltyDashboardLazyQueryHookResult = ReturnType<typeof useLoyaltyDashboardLazyQuery>;
export type LoyaltyDashboardQueryResult = Apollo.QueryResult<LoyaltyDashboardQuery, LoyaltyDashboardQueryVariables>;
export const LoyaltyHistoryDocument = gql`
    query LoyaltyHistory {
  loyaltyHistory {
    items {
      action
      actionName
      date
      completedAt
      points
      status
      createdAt
    }
  }
}
    `;

/**
 * __useLoyaltyHistoryQuery__
 *
 * To run a query within a React component, call `useLoyaltyHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyHistoryQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyHistoryQuery, LoyaltyHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyHistoryQuery, LoyaltyHistoryQueryVariables>(LoyaltyHistoryDocument, options);
      }
export function useLoyaltyHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyHistoryQuery, LoyaltyHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyHistoryQuery, LoyaltyHistoryQueryVariables>(LoyaltyHistoryDocument, options);
        }
export type LoyaltyHistoryQueryHookResult = ReturnType<typeof useLoyaltyHistoryQuery>;
export type LoyaltyHistoryLazyQueryHookResult = ReturnType<typeof useLoyaltyHistoryLazyQuery>;
export type LoyaltyHistoryQueryResult = Apollo.QueryResult<LoyaltyHistoryQuery, LoyaltyHistoryQueryVariables>;
export const LoyaltyOptInDocument = gql`
    mutation LoyaltyOptIn {
  loyaltyOptIn {
    ok
    user {
      profile {
        preferences
      }
    }
  }
}
    `;
export type LoyaltyOptInMutationFn = Apollo.MutationFunction<LoyaltyOptInMutation, LoyaltyOptInMutationVariables>;

/**
 * __useLoyaltyOptInMutation__
 *
 * To run a mutation, you first call `useLoyaltyOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyOptInMutation, { data, loading, error }] = useLoyaltyOptInMutation({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyOptInMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyOptInMutation, LoyaltyOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyOptInMutation, LoyaltyOptInMutationVariables>(LoyaltyOptInDocument, options);
      }
export type LoyaltyOptInMutationHookResult = ReturnType<typeof useLoyaltyOptInMutation>;
export type LoyaltyOptInMutationResult = Apollo.MutationResult<LoyaltyOptInMutation>;
export type LoyaltyOptInMutationOptions = Apollo.BaseMutationOptions<LoyaltyOptInMutation, LoyaltyOptInMutationVariables>;
export const LoyaltyOptOutDocument = gql`
    mutation LoyaltyOptOut {
  loyaltyOptOut {
    ok
    user {
      profile {
        preferences
      }
    }
  }
}
    `;
export type LoyaltyOptOutMutationFn = Apollo.MutationFunction<LoyaltyOptOutMutation, LoyaltyOptOutMutationVariables>;

/**
 * __useLoyaltyOptOutMutation__
 *
 * To run a mutation, you first call `useLoyaltyOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyOptOutMutation, { data, loading, error }] = useLoyaltyOptOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyOptOutMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyOptOutMutation, LoyaltyOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyOptOutMutation, LoyaltyOptOutMutationVariables>(LoyaltyOptOutDocument, options);
      }
export type LoyaltyOptOutMutationHookResult = ReturnType<typeof useLoyaltyOptOutMutation>;
export type LoyaltyOptOutMutationResult = Apollo.MutationResult<LoyaltyOptOutMutation>;
export type LoyaltyOptOutMutationOptions = Apollo.BaseMutationOptions<LoyaltyOptOutMutation, LoyaltyOptOutMutationVariables>;
export const LoyaltyRedemptionOptionRedeemDocument = gql`
    mutation LoyaltyRedemptionOptionRedeem($id: Int!, $name: String!) {
  loyaltyRedemptionOptionRedeem(
    redemptionOptionId: $id
    redemptionOptionName: $name
  ) {
    approved
    ok
    rewardText
    token
    errors {
      field
      error
    }
  }
}
    `;
export type LoyaltyRedemptionOptionRedeemMutationFn = Apollo.MutationFunction<LoyaltyRedemptionOptionRedeemMutation, LoyaltyRedemptionOptionRedeemMutationVariables>;

/**
 * __useLoyaltyRedemptionOptionRedeemMutation__
 *
 * To run a mutation, you first call `useLoyaltyRedemptionOptionRedeemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRedemptionOptionRedeemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyRedemptionOptionRedeemMutation, { data, loading, error }] = useLoyaltyRedemptionOptionRedeemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useLoyaltyRedemptionOptionRedeemMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyRedemptionOptionRedeemMutation, LoyaltyRedemptionOptionRedeemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyRedemptionOptionRedeemMutation, LoyaltyRedemptionOptionRedeemMutationVariables>(LoyaltyRedemptionOptionRedeemDocument, options);
      }
export type LoyaltyRedemptionOptionRedeemMutationHookResult = ReturnType<typeof useLoyaltyRedemptionOptionRedeemMutation>;
export type LoyaltyRedemptionOptionRedeemMutationResult = Apollo.MutationResult<LoyaltyRedemptionOptionRedeemMutation>;
export type LoyaltyRedemptionOptionRedeemMutationOptions = Apollo.BaseMutationOptions<LoyaltyRedemptionOptionRedeemMutation, LoyaltyRedemptionOptionRedeemMutationVariables>;
export const LoyaltyDocument = gql`
    query Loyalty {
  loyaltyCampaigns {
    campaigns {
      ...campaign
    }
    title
  }
  loyaltyFAQs {
    ...loyaltyFAQs
  }
  loyaltyPerks {
    ...loyaltyPerks
  }
  loyaltyRedemptionOptions {
    ...loyaltyRedemptionOptions
  }
  loyaltySteps {
    description
    steps {
      description
      label
      title
      id
    }
    title
  }
  loyaltyTiers {
    tiers {
      ...tier
    }
  }
}
    ${CampaignFragmentDoc}
${LoyaltyFaQsFragmentDoc}
${LoyaltyPerksFragmentDoc}
${LoyaltyRedemptionOptionsFragmentDoc}
${TierFragmentDoc}`;

/**
 * __useLoyaltyQuery__
 *
 * To run a query within a React component, call `useLoyaltyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyQuery, LoyaltyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyQuery, LoyaltyQueryVariables>(LoyaltyDocument, options);
      }
export function useLoyaltyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyQuery, LoyaltyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyQuery, LoyaltyQueryVariables>(LoyaltyDocument, options);
        }
export type LoyaltyQueryHookResult = ReturnType<typeof useLoyaltyQuery>;
export type LoyaltyLazyQueryHookResult = ReturnType<typeof useLoyaltyLazyQuery>;
export type LoyaltyQueryResult = Apollo.QueryResult<LoyaltyQuery, LoyaltyQueryVariables>;
export const LoyaltyStatusDocument = gql`
    query LoyaltyStatus {
  loyaltyStatus {
    id
    pointsBalance
    pointsExpireAt
    optIn
    tierName
  }
}
    `;

/**
 * __useLoyaltyStatusQuery__
 *
 * To run a query within a React component, call `useLoyaltyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyStatusQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyStatusQuery, LoyaltyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyStatusQuery, LoyaltyStatusQueryVariables>(LoyaltyStatusDocument, options);
      }
export function useLoyaltyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyStatusQuery, LoyaltyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyStatusQuery, LoyaltyStatusQueryVariables>(LoyaltyStatusDocument, options);
        }
export type LoyaltyStatusQueryHookResult = ReturnType<typeof useLoyaltyStatusQuery>;
export type LoyaltyStatusLazyQueryHookResult = ReturnType<typeof useLoyaltyStatusLazyQuery>;
export type LoyaltyStatusQueryResult = Apollo.QueryResult<LoyaltyStatusQuery, LoyaltyStatusQueryVariables>;
export const LoyaltySubscribeDocument = gql`
    mutation LoyaltySubscribe($id: String!) {
  loyaltySubscribe(id: $id) {
    id
    profile {
      preferences
    }
  }
}
    `;
export type LoyaltySubscribeMutationFn = Apollo.MutationFunction<LoyaltySubscribeMutation, LoyaltySubscribeMutationVariables>;

/**
 * __useLoyaltySubscribeMutation__
 *
 * To run a mutation, you first call `useLoyaltySubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltySubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltySubscribeMutation, { data, loading, error }] = useLoyaltySubscribeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltySubscribeMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltySubscribeMutation, LoyaltySubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltySubscribeMutation, LoyaltySubscribeMutationVariables>(LoyaltySubscribeDocument, options);
      }
export type LoyaltySubscribeMutationHookResult = ReturnType<typeof useLoyaltySubscribeMutation>;
export type LoyaltySubscribeMutationResult = Apollo.MutationResult<LoyaltySubscribeMutation>;
export type LoyaltySubscribeMutationOptions = Apollo.BaseMutationOptions<LoyaltySubscribeMutation, LoyaltySubscribeMutationVariables>;
export const LoyaltyUnsubscribeDocument = gql`
    mutation LoyaltyUnsubscribe($id: String!) {
  loyaltyUnsubscribe(id: $id) {
    id
    profile {
      preferences
    }
  }
}
    `;
export type LoyaltyUnsubscribeMutationFn = Apollo.MutationFunction<LoyaltyUnsubscribeMutation, LoyaltyUnsubscribeMutationVariables>;

/**
 * __useLoyaltyUnsubscribeMutation__
 *
 * To run a mutation, you first call `useLoyaltyUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyUnsubscribeMutation, { data, loading, error }] = useLoyaltyUnsubscribeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoyaltyUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<LoyaltyUnsubscribeMutation, LoyaltyUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoyaltyUnsubscribeMutation, LoyaltyUnsubscribeMutationVariables>(LoyaltyUnsubscribeDocument, options);
      }
export type LoyaltyUnsubscribeMutationHookResult = ReturnType<typeof useLoyaltyUnsubscribeMutation>;
export type LoyaltyUnsubscribeMutationResult = Apollo.MutationResult<LoyaltyUnsubscribeMutation>;
export type LoyaltyUnsubscribeMutationOptions = Apollo.BaseMutationOptions<LoyaltyUnsubscribeMutation, LoyaltyUnsubscribeMutationVariables>;
export const ProgramsDocument = gql`
    query Programs {
  eligiblePrograms: programs(eligible: true) {
    id
    title
    questions
    preActivationDescription
    preActivationTitle
  }
  programs {
    id
    title
    postActivationDescription
    postActivationTitle
    postActivationCTA
    postActivationURL
  }
}
    `;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const RecreationalistLatestDocument = gql`
    query RecreationalistLatest {
  recreationalistLatest {
    image
    link
    title
    category
    description
  }
}
    `;

/**
 * __useRecreationalistLatestQuery__
 *
 * To run a query within a React component, call `useRecreationalistLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecreationalistLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecreationalistLatestQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecreationalistLatestQuery(baseOptions?: Apollo.QueryHookOptions<RecreationalistLatestQuery, RecreationalistLatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecreationalistLatestQuery, RecreationalistLatestQueryVariables>(RecreationalistLatestDocument, options);
      }
export function useRecreationalistLatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecreationalistLatestQuery, RecreationalistLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecreationalistLatestQuery, RecreationalistLatestQueryVariables>(RecreationalistLatestDocument, options);
        }
export type RecreationalistLatestQueryHookResult = ReturnType<typeof useRecreationalistLatestQuery>;
export type RecreationalistLatestLazyQueryHookResult = ReturnType<typeof useRecreationalistLatestLazyQuery>;
export type RecreationalistLatestQueryResult = Apollo.QueryResult<RecreationalistLatestQuery, RecreationalistLatestQueryVariables>;
export const SchoolColorDocument = gql`
    query SchoolColor($email: String!) {
  schoolColor(email: $email) {
    primaryColor
    secondaryColor
    name
  }
}
    `;

/**
 * __useSchoolColorQuery__
 *
 * To run a query within a React component, call `useSchoolColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolColorQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSchoolColorQuery(baseOptions: Apollo.QueryHookOptions<SchoolColorQuery, SchoolColorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolColorQuery, SchoolColorQueryVariables>(SchoolColorDocument, options);
      }
export function useSchoolColorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolColorQuery, SchoolColorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolColorQuery, SchoolColorQueryVariables>(SchoolColorDocument, options);
        }
export type SchoolColorQueryHookResult = ReturnType<typeof useSchoolColorQuery>;
export type SchoolColorLazyQueryHookResult = ReturnType<typeof useSchoolColorLazyQuery>;
export type SchoolColorQueryResult = Apollo.QueryResult<SchoolColorQuery, SchoolColorQueryVariables>;
export const UserEditDocument = gql`
    mutation UserEdit($input: UserEditInput!) {
  userEdit(input: $input) {
    ...user
    profile {
      id
      birthday
      shoppingFor
    }
  }
}
    ${UserFragmentDoc}`;
export type UserEditMutationFn = Apollo.MutationFunction<UserEditMutation, UserEditMutationVariables>;

/**
 * __useUserEditMutation__
 *
 * To run a mutation, you first call `useUserEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userEditMutation, { data, loading, error }] = useUserEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserEditMutation(baseOptions?: Apollo.MutationHookOptions<UserEditMutation, UserEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserEditMutation, UserEditMutationVariables>(UserEditDocument, options);
      }
export type UserEditMutationHookResult = ReturnType<typeof useUserEditMutation>;
export type UserEditMutationResult = Apollo.MutationResult<UserEditMutation>;
export type UserEditMutationOptions = Apollo.BaseMutationOptions<UserEditMutation, UserEditMutationVariables>;
export const UserForgotPasswordDocument = gql`
    mutation UserForgotPassword($email: String!) {
  userForgotPassword(email: $email) {
    ok
  }
}
    `;
export type UserForgotPasswordMutationFn = Apollo.MutationFunction<UserForgotPasswordMutation, UserForgotPasswordMutationVariables>;

/**
 * __useUserForgotPasswordMutation__
 *
 * To run a mutation, you first call `useUserForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userForgotPasswordMutation, { data, loading, error }] = useUserForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserForgotPasswordMutation, UserForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserForgotPasswordMutation, UserForgotPasswordMutationVariables>(UserForgotPasswordDocument, options);
      }
export type UserForgotPasswordMutationHookResult = ReturnType<typeof useUserForgotPasswordMutation>;
export type UserForgotPasswordMutationResult = Apollo.MutationResult<UserForgotPasswordMutation>;
export type UserForgotPasswordMutationOptions = Apollo.BaseMutationOptions<UserForgotPasswordMutation, UserForgotPasswordMutationVariables>;
export const UserLoginDocument = gql`
    mutation UserLogin($email: String!, $password: String!, $recaptchaToken: String) {
  userLogin(email: $email, password: $password, recaptchaToken: $recaptchaToken) {
    accessToken
    hasPassword
    invalidRecaptcha
    isVerified
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type UserLoginMutationFn = Apollo.MutationFunction<UserLoginMutation, UserLoginMutationVariables>;

/**
 * __useUserLoginMutation__
 *
 * To run a mutation, you first call `useUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLoginMutation, { data, loading, error }] = useUserLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<UserLoginMutation, UserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLoginMutation, UserLoginMutationVariables>(UserLoginDocument, options);
      }
export type UserLoginMutationHookResult = ReturnType<typeof useUserLoginMutation>;
export type UserLoginMutationResult = Apollo.MutationResult<UserLoginMutation>;
export type UserLoginMutationOptions = Apollo.BaseMutationOptions<UserLoginMutation, UserLoginMutationVariables>;
export const UserLogoutDocument = gql`
    mutation UserLogout {
  userLogout
}
    `;
export type UserLogoutMutationFn = Apollo.MutationFunction<UserLogoutMutation, UserLogoutMutationVariables>;

/**
 * __useUserLogoutMutation__
 *
 * To run a mutation, you first call `useUserLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLogoutMutation, { data, loading, error }] = useUserLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserLogoutMutation(baseOptions?: Apollo.MutationHookOptions<UserLogoutMutation, UserLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLogoutMutation, UserLogoutMutationVariables>(UserLogoutDocument, options);
      }
export type UserLogoutMutationHookResult = ReturnType<typeof useUserLogoutMutation>;
export type UserLogoutMutationResult = Apollo.MutationResult<UserLogoutMutation>;
export type UserLogoutMutationOptions = Apollo.BaseMutationOptions<UserLogoutMutation, UserLogoutMutationVariables>;
export const MeWithProfileDocument = gql`
    query MeWithProfile {
  me {
    ...user
    profile {
      id
      birthday
      shoppingFor
      phoneNumber
      preferences
      avatar {
        ...image
      }
    }
  }
}
    ${UserFragmentDoc}
${ImageFragmentDoc}`;

/**
 * __useMeWithProfileQuery__
 *
 * To run a query within a React component, call `useMeWithProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeWithProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeWithProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeWithProfileQuery(baseOptions?: Apollo.QueryHookOptions<MeWithProfileQuery, MeWithProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeWithProfileQuery, MeWithProfileQueryVariables>(MeWithProfileDocument, options);
      }
export function useMeWithProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeWithProfileQuery, MeWithProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeWithProfileQuery, MeWithProfileQueryVariables>(MeWithProfileDocument, options);
        }
export type MeWithProfileQueryHookResult = ReturnType<typeof useMeWithProfileQuery>;
export type MeWithProfileLazyQueryHookResult = ReturnType<typeof useMeWithProfileLazyQuery>;
export type MeWithProfileQueryResult = Apollo.QueryResult<MeWithProfileQuery, MeWithProfileQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const OrdersRecentDocument = gql`
    query OrdersRecent($id: Float!) {
  ordersRecent(id: $id) {
    creditCardNumber
    creditCardCompany
    lineItems {
      shopifyVariantId
      shopifyProductId
      name
      image {
        alt
        src
        height
        width
      }
    }
  }
}
    `;

/**
 * __useOrdersRecentQuery__
 *
 * To run a query within a React component, call `useOrdersRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersRecentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrdersRecentQuery(baseOptions: Apollo.QueryHookOptions<OrdersRecentQuery, OrdersRecentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersRecentQuery, OrdersRecentQueryVariables>(OrdersRecentDocument, options);
      }
export function useOrdersRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersRecentQuery, OrdersRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersRecentQuery, OrdersRecentQueryVariables>(OrdersRecentDocument, options);
        }
export type OrdersRecentQueryHookResult = ReturnType<typeof useOrdersRecentQuery>;
export type OrdersRecentLazyQueryHookResult = ReturnType<typeof useOrdersRecentLazyQuery>;
export type OrdersRecentQueryResult = Apollo.QueryResult<OrdersRecentQuery, OrdersRecentQueryVariables>;
export const UserProgramCreateDocument = gql`
    mutation UserProgramCreate($programId: String!, $answers: String!) {
  userProgramCreate(programId: $programId, answers: $answers) {
    id
    program {
      id
      title
      postActivationDescription
      postActivationTitle
      postActivationCTA
      postActivationURL
    }
  }
}
    `;
export type UserProgramCreateMutationFn = Apollo.MutationFunction<UserProgramCreateMutation, UserProgramCreateMutationVariables>;

/**
 * __useUserProgramCreateMutation__
 *
 * To run a mutation, you first call `useUserProgramCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProgramCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProgramCreateMutation, { data, loading, error }] = useUserProgramCreateMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useUserProgramCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserProgramCreateMutation, UserProgramCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserProgramCreateMutation, UserProgramCreateMutationVariables>(UserProgramCreateDocument, options);
      }
export type UserProgramCreateMutationHookResult = ReturnType<typeof useUserProgramCreateMutation>;
export type UserProgramCreateMutationResult = Apollo.MutationResult<UserProgramCreateMutation>;
export type UserProgramCreateMutationOptions = Apollo.BaseMutationOptions<UserProgramCreateMutation, UserProgramCreateMutationVariables>;
export const UserRegisterDocument = gql`
    mutation UserRegister($input: RegisterInput!, $recaptchaToken: String) {
  userRegister(input: $input, recaptchaToken: $recaptchaToken) {
    accessToken
    invalidRecaptcha
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type UserRegisterMutationFn = Apollo.MutationFunction<UserRegisterMutation, UserRegisterMutationVariables>;

/**
 * __useUserRegisterMutation__
 *
 * To run a mutation, you first call `useUserRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRegisterMutation, { data, loading, error }] = useUserRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useUserRegisterMutation(baseOptions?: Apollo.MutationHookOptions<UserRegisterMutation, UserRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRegisterMutation, UserRegisterMutationVariables>(UserRegisterDocument, options);
      }
export type UserRegisterMutationHookResult = ReturnType<typeof useUserRegisterMutation>;
export type UserRegisterMutationResult = Apollo.MutationResult<UserRegisterMutation>;
export type UserRegisterMutationOptions = Apollo.BaseMutationOptions<UserRegisterMutation, UserRegisterMutationVariables>;
export const UserSetPasswordWithAccessTokenDocument = gql`
    mutation UserSetPasswordWithAccessToken($input: SetPasswordWithAccessTokenInput!) {
  userSetPasswordWithAccessToken(input: $input) {
    accessToken
    hasPassword
    isVerified
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type UserSetPasswordWithAccessTokenMutationFn = Apollo.MutationFunction<UserSetPasswordWithAccessTokenMutation, UserSetPasswordWithAccessTokenMutationVariables>;

/**
 * __useUserSetPasswordWithAccessTokenMutation__
 *
 * To run a mutation, you first call `useUserSetPasswordWithAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetPasswordWithAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetPasswordWithAccessTokenMutation, { data, loading, error }] = useUserSetPasswordWithAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSetPasswordWithAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<UserSetPasswordWithAccessTokenMutation, UserSetPasswordWithAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSetPasswordWithAccessTokenMutation, UserSetPasswordWithAccessTokenMutationVariables>(UserSetPasswordWithAccessTokenDocument, options);
      }
export type UserSetPasswordWithAccessTokenMutationHookResult = ReturnType<typeof useUserSetPasswordWithAccessTokenMutation>;
export type UserSetPasswordWithAccessTokenMutationResult = Apollo.MutationResult<UserSetPasswordWithAccessTokenMutation>;
export type UserSetPasswordWithAccessTokenMutationOptions = Apollo.BaseMutationOptions<UserSetPasswordWithAccessTokenMutation, UserSetPasswordWithAccessTokenMutationVariables>;
export const UserSetPasswordWithPasswordDocument = gql`
    mutation UserSetPasswordWithPassword($input: SetPasswordWithPasswordInput!) {
  userSetPasswordWithPassword(input: $input) {
    ok
  }
}
    `;
export type UserSetPasswordWithPasswordMutationFn = Apollo.MutationFunction<UserSetPasswordWithPasswordMutation, UserSetPasswordWithPasswordMutationVariables>;

/**
 * __useUserSetPasswordWithPasswordMutation__
 *
 * To run a mutation, you first call `useUserSetPasswordWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetPasswordWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetPasswordWithPasswordMutation, { data, loading, error }] = useUserSetPasswordWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSetPasswordWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserSetPasswordWithPasswordMutation, UserSetPasswordWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSetPasswordWithPasswordMutation, UserSetPasswordWithPasswordMutationVariables>(UserSetPasswordWithPasswordDocument, options);
      }
export type UserSetPasswordWithPasswordMutationHookResult = ReturnType<typeof useUserSetPasswordWithPasswordMutation>;
export type UserSetPasswordWithPasswordMutationResult = Apollo.MutationResult<UserSetPasswordWithPasswordMutation>;
export type UserSetPasswordWithPasswordMutationOptions = Apollo.BaseMutationOptions<UserSetPasswordWithPasswordMutation, UserSetPasswordWithPasswordMutationVariables>;
export const UserSetPasswordWithTokenDocument = gql`
    mutation UserSetPasswordWithToken($input: SetPasswordWithTokenInput!) {
  userSetPasswordWithToken(input: $input) {
    ok
  }
}
    `;
export type UserSetPasswordWithTokenMutationFn = Apollo.MutationFunction<UserSetPasswordWithTokenMutation, UserSetPasswordWithTokenMutationVariables>;

/**
 * __useUserSetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useUserSetPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetPasswordWithTokenMutation, { data, loading, error }] = useUserSetPasswordWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSetPasswordWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<UserSetPasswordWithTokenMutation, UserSetPasswordWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSetPasswordWithTokenMutation, UserSetPasswordWithTokenMutationVariables>(UserSetPasswordWithTokenDocument, options);
      }
export type UserSetPasswordWithTokenMutationHookResult = ReturnType<typeof useUserSetPasswordWithTokenMutation>;
export type UserSetPasswordWithTokenMutationResult = Apollo.MutationResult<UserSetPasswordWithTokenMutation>;
export type UserSetPasswordWithTokenMutationOptions = Apollo.BaseMutationOptions<UserSetPasswordWithTokenMutation, UserSetPasswordWithTokenMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    